import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import PriceChangeOutlinedIcon from "@mui/icons-material/PriceChangeOutlined";
import { Card, CardActionArea, CardContent, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import "./administracion-web.scss";

const modulos = [
  {
    path: "/web/autoridades",
    titulo: "Autoridades",
    descripcion: "Comisión Directiva, Tribunal de Ética y Comisión Revisora",
    icon: <GroupOutlinedIcon sx={{ fontSize: 48, color: "#1976d2" }} />,
    color: "#1976d2",
    disponible: false,
  },
  {
    path: "/web/aranceles",
    titulo: "Aranceles",
    descripcion: "Valores de matriculación y cuotas vigentes",
    icon: <PriceChangeOutlinedIcon sx={{ fontSize: 48, color: "#2e7d32" }} />,
    color: "#2e7d32",
    disponible: false,
  },
  {
    path: "/web/documentos",
    titulo: "Documentos",
    descripcion: "PDFs de trámites, honorarios y normativas",
    icon: (
      <InsertDriveFileOutlinedIcon sx={{ fontSize: 48, color: "#7b1fa2" }} />
    ),
    color: "#7b1fa2",
    disponible: false,
  },
  {
    path: "/web/eventos",
    titulo: "Cursos y Eventos",
    descripcion: "Administre los cursos, eventos y novedades del portal",
    icon: <CalendarMonthOutlinedIcon sx={{ fontSize: 48, color: "#ed6c02" }} />,
    color: "#ed6c02",
    disponible: true,
  },
];

export default function AdministracionWeb() {
  const navigate = useNavigate();

  return (
    <div className="administracion-web">
      <div className="header-section">
        <h1>Administración del Portal Web</h1>
        <p>Gestione el contenido y la información pública del portal</p>
      </div>

      <div className="secciones-grid">
        {modulos.map((mod) => (
          <Card
            key={mod.path}
            className={`seccion-card${mod.disponible ? "" : " seccion-card--disabled"}`}
            sx={{ borderColor: mod.color }}
          >
            <CardActionArea
              onClick={() => mod.disponible && navigate(mod.path)}
              disabled={!mod.disponible}
              sx={{ height: "100%" }}
            >
              <CardContent>
                {!mod.disponible && (
                  <span className="coming-soon-badge">Próximamente</span>
                )}
                <div className="seccion-header">
                  <div className="seccion-icon">{mod.icon}</div>
                  <div className="seccion-info">
                    <Typography
                      variant="h6"
                      component="h3"
                      sx={{ color: mod.color, fontWeight: 600 }}
                    >
                      {mod.titulo}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {mod.descripcion}
                    </Typography>
                  </div>
                </div>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </div>
    </div>
  );
}
